import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconMinus = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--minus")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M5,13 L19,13 C19.5522847,13 20,12.5522847 20,12 C20,11.4477153 19.5522847,11 19,11 L5,11 C4.44771525,11 4,11.4477153 4,12 C4,12.5522847 4.44771525,13 5,13 Z" id="icon--centivo--minus"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-377.000000, -860.000000)"/>
          <g id="Icon/minus">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--minus"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--minus"/>
          </g>
      </g>
  </IconWrapper>
)
